module.exports = "/_next/static/images/FreePlan-xs-54a1172527a79156809054fff074b95c.png";